import { MilanoteHotTableInstance } from '../../../tableHotInstanceTypes';

const BORDER_PX = 1;

const getHorizontalBorderOffset = (col: number) => {
    return col === 0 ? 0 : BORDER_PX;
};

export const getEditorWidth = (hotInstance: MilanoteHotTableInstance, row: number, col: number) => {
    const cell = hotInstance.getCell(row, col);
    const cellWidth = cell?.offsetWidth || 0;

    return cellWidth + getHorizontalBorderOffset(col);
};
